import { useState } from "react"

export const useSelectPhoto = (
  handleFileSelected: (file: File | null) => void,
  disable: boolean,
  onBeforeSelect?: (file: File) => Promise<File | null>,
  inputId = "fileInput",
) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const [imageLoaded, setImageLoaded] = useState<boolean>(false)

  const [errorOccurred, setErrorOccurred] = useState<boolean>(false)

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  const handleImageError = () => {
    setImageLoaded(true)

    setErrorOccurred(true)
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (file && file.type.includes("image")) {
      const finalFile = onBeforeSelect ? await onBeforeSelect(file) : file

      if (finalFile) {
        setSelectedFile(finalFile)

        handleFileSelected(finalFile)
      }
    } else {
      setSelectedFile(null)

      handleFileSelected(null)
    }

    e.target.value = ""
  }

  const handleOpenFileDialog = () => {
    if (!disable) {
      document.getElementById(inputId)?.click()
    }
  }

  return {
    selectedFile,
    imageLoaded,
    errorOccurred,
    setSelectedFile,
    handleImageError,
    handleImageLoad,
    handleFileChange,
    handleOpenFileDialog,
  }
}
